import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_THREE_DOTS_VERTICAL: GlameraIconDefinition = {
  name: '3-dots-vertical',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-3-dots-vertical-dot glm-3-dots-vertical-dot-1" cx="12" cy="5" r="1"></circle>
    <circle class="glm-3-dots-vertical-dot glm-3-dots-vertical-dot-2" cx="12" cy="12" r="1"></circle>
    <circle class="glm-3-dots-vertical-dot glm-3-dots-vertical-dot-3" cx="12" cy="19" r="1"></circle>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-3-dots-vertical-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './3-dots-vertical.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ThreeDotsVerticalIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_THREE_DOTS_VERTICAL;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
